/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DisplayShortcut from "./DisplayShortcut.jsx";
import KeyPressed from "./KeyPressed.jsx";
import DisplayIcon from "../Icons/DisplayIcon.jsx";

class IconWithShortcut extends Component {
    render() {
        let {shortcuts, className = "", iconName} = this.props
        return (
            <>
                <KeyPressed shortcut={["ctrl", "command"]}>
                    {isActive => (<>
                        {isActive ? (
                            <div className={className + " flex items-center justify-center"}>
                                <DisplayShortcut shortcuts={shortcuts}/>
                            </div>
                        ) : (<>
                            <DisplayIcon iconName={iconName}
                                         className={className}/>
                        </>)}
                    </>)}
                </KeyPressed>
            </>
        );
    }
}

IconWithShortcut.propTypes = {
    shortcuts: PropTypes.array,
    className: PropTypes.string,
    iconName: PropTypes.any
};

IconWithShortcut.defaultProps = {};


export default IconWithShortcut;